/*
 * O CTA que abre o cadastro no passo de mapa astral — o `birthchart_cta.php` em React.
 *
 * Quem levanta a modal continua sendo a PÁGINA: `onOpenStyledModal` vive num `<script>` do
 * `artigo.php` porque conhece o `modalId` do `styledModal` e o ajuste de `font-size` do root
 * (AL-3260). Chamá-lo por `window` mantém essa fronteira — o módulo não recria a modal.
 */
import React, { useCallback } from 'react';

declare global {
    interface Window {
        /** Publicada por `artigo.php`; ausente se o bloco de scripts da página não rodou. */
        onOpenStyledModal?: (initialStep: string) => void;
    }
}

interface IContentCtaProps {
    /** Passo inicial do `AuthFunctional`, ex.: `SIGNUP:BIRTH_DATA`. */
    step: string;
    /** Rótulo do botão, já traduzido; pode trazer `<strong>`. */
    label: string;
    /** Chamada opcional acima do botão. */
    title?: string;
    /** Ícone opcional à esquerda do rótulo. */
    iconSrc?: string;
}

const ContentCta: React.FC<IContentCtaProps> = ({ step, label, title, iconSrc }) => {
    const handleClick = useCallback(() => {
        if (typeof window.onOpenStyledModal === 'function') window.onOpenStyledModal(step);
    }, [step]);

    if (!label || !step) return null;

    return (
        <div className="content-cta">
            {Boolean(title) && <span className="content-cta__title">{title}</span>}

            <button
                type="button"
                className="content-cta__button btn btn-lg button-articles"
                onClick={handleClick}
            >
                {Boolean(iconSrc) && <img className="content-cta__icon" src={iconSrc} width="24" alt="" />}

                {/* O rótulo vem com `<strong>` das chaves de `posts`, não é texto puro. */}
                <span dangerouslySetInnerHTML={{ __html: label }} />
            </button>
        </div>
    );
};

export default ContentCta;
